import { IconBookmark, IconBuildings, IconCoil, IconEnergyCircle, IconRuler, IconShare, IconSignal, IconTools } from '@assets/images/icon';
import { bell1 } from '@assets/images/main/iot/product';
import { airQuality1, coMeasure1, sensorThumb } from '@assets/images/main/sensor';

export default {
  a: [
    { text: 'Ứng dụng chính', icon: IconCoil },
    { text: 'Các hạng mục đo lường', icon: IconRuler },
    { text: 'Băng tần truyền thông', icon: IconSignal },
    { text: 'Môi trường lắp đặt', icon: IconEnergyCircle },
    { text: 'Nguồn điện', icon: IconTools },
    { text: 'Tóm tắt đặc điểm', icon: IconBuildings },
    { text: 'Tích hợp với ORBRO', icon: IconBookmark },
    { text: 'Kết nối bên ngoài', icon: IconShare },
  ],

  b: [
    { text: 'Giám sát tình trạng thiết bị tại hiện trường công nghiệp' },
    { text: 'Nhiệt độ, độ ẩm, rò rỉ nước, áp suất, rung động, tiếp điểm, v.v.' },
    { text: 'LoRa, RS-485' },
    { text: 'Công trường xây dựng, nhà máy, kho logistics, v.v.' },
    { text: 'Pin / Nguồn DC' },
    { text: 'Hỗ trợ nhiều loại cảm biến, kết nối không dây LoRa với phạm vi 6km' },
    { text: 'Hỗ trợ' },
    { text: 'Cung cấp API' },
  ],

  c: [
    { text: 'Phát hiện và cảnh báo rò rỉ CO₂' },
    { text: 'CO, nhiệt độ' },
    { text: 'Wi-Fi, RS-485' },
    { text: 'Khu vực kín, nhà máy xử lý nước thải, cơ sở xử lý chất thải, v.v.' },
    { text: 'Pin / Nguồn DC' },
    { text: 'Cảm biến chuyên biệt đo CO₂, phù hợp cho các khu vực nguy hiểm và nhạy cảm' },
    { text: 'Hỗ trợ' },
    { text: 'Cung cấp API' },
  ],

  d: [
    { text: 'Theo dõi chất lượng không khí trong nhà' },
    { text: 'Bụi mịn, CO₂, TVOC, nhiệt độ và độ ẩm' },
    { text: 'Wi-Fi, RS-485' },
    { text: 'Môi trường trong nhà như bệnh viện, văn phòng, cơ sở công cộng' },
    { text: 'DC 24V' },
    { text: 'Phân tích chất lượng không khí với độ chính xác cao, đạt chứng nhận từ Bộ Môi trường' },
    { text: 'Hỗ trợ' },
    { text: 'Cung cấp API' },
  ],

  e: [
    { text: 'Gửi cảnh báo trong tình huống khẩn cấp' },
    { text: 'Trạng thái nút báo động khẩn cấp' },
    { text: 'Bluetooth 5, Wi-Fi' },
    { text: 'Bệnh viện, kho hàng, văn phòng, hành lang tại khu vực' },
    { text: 'Pin AAA' },
    { text: 'Hỗ trợ gửi tin nhắn SMS, kết nối Wi-Fi, vận hành tiêu thụ điện năng thấp' },
    { text: 'Hỗ trợ' },
    { text: 'Cung cấp API' },
  ],

  spec: [
    {},

    {
      image: sensorThumb,
      link: '/vi/iot/LoRASensor',
      title: 'LoRa Sensor',
      desc: 'Mới',
    },
    {
      image: coMeasure1,
      link: '/vi/iot/co2',
      title: 'Máy đo CO₂',
      desc: 'Mới',
    },
    {
      image: airQuality1,
      link: '/vi/iot/air',
      title: 'Máy đo chất lượng không khí',
      desc: 'Mới',
    },
    {
      image: bell1,
      link: '/vi/iot/bell',
      title: 'Chuông báo khẩn cấp',
      desc: '',
    },
  ],
};
